import { rem } from "polished";

import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import {
  ColorLabels,
  getInvertedColor,
} from "@/components/editor/utils/colors";

export const BlockBackground = withViewportStyle("div")`
  background: linear-gradient(${({ theme }) =>
    theme.colors[ColorLabels.VISUALS_2]} 20%, ${({ theme }) =>
  theme.colors[ColorLabels.VISUALS]} 20% 80%, ${({ theme }) =>
  theme.colors[ColorLabels.VISUALS_2]} 80%);

  ${(props) => props.$viewport.mobile`
    background: ${({ theme }) => theme.colors[ColorLabels.VISUALS_2]};
  `}
`;

export const PaddingWrapper = withViewportStyle(BlockPaddingWrapper)`
  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)};
  `}
`;

export const ContentContainer = withViewportStyle("div")`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  gap: ${rem(128)};

  ${(props) => props.$viewport.tablet`
    gap: ${rem(24)};
  `}

  ${(props) => props.$viewport.mobile`
    grid-template-columns: 1fr;

    .paragraph-item-sub-title {
      background: ${({ theme }) => theme.colors[ColorLabels.VISUALS]};
      padding: ${rem(16)};
    }
  `}

  .image-primitive {
    max-width: ${rem(496)};
    max-height: ${rem(496)};
    margin: auto;
  }

  .nolan .ck-content p, 
  .nolan .ck-content h1, 
  .nolan .ck-content h2, 
  .nolan .ck-content h3, 
  .nolan .ck-content h4,
  .nolan .ck-content h5,
  .nolan .ck-content li {
    color: ${({ theme }) =>
      theme.colors[ColorLabels.SECONDARY_FONT]} !important;
  }

  .button-primitive {
    background: ${({ theme }) => theme.colors[ColorLabels.SECONDARY]};
    color: ${({ theme }) =>
      getInvertedColor(theme.colors[ColorLabels.SECONDARY])};
  }
`;
